module.exports = __webpack_public_path__ + "static/img/penny_profile_800x657.e6ee775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_profile_800x657.jpg
// module id = dfz5
// module chunks = 0